import { fetchClient } from '@nike/fetch-client';
import makeQueryKey from "../../../../utils/make-query-key";
var getFetchDesignViewsOptions = function getFetchDesignViewsOptions(_ref) {
  var designViewId = _ref.designViewId;
  return {
    queryKey: makeQueryKey(['design_views/v1', {
      designViewId: designViewId
    }]),
    queryFn: function queryFn() {
      return fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/customization/design_views/v1/").concat(designViewId));
    }
  };
};
export default getFetchDesignViewsOptions;